module.exports = __webpack_public_path__ + "img/jincheng.4307b7e8.jpg";